/** @jsx jsx */
import { jsx, ThemeUIStyleObject } from "theme-ui";
import React from "react";
import { Box } from "@shared-components/Box/Box";
import { Heading } from "@shared-components/Heading/Heading";
import { Text } from "@shared-components/Text/Text";
import {
  containerStyles,
  blockquoteWrapStyles,
  blockquoteStyles,
  blockquoteCiteStyles,
  containerSpecialStyles,
  blockquoteWrapSpecialStyles,
  blockquoteTitleSpecialStyles,
  blockquoteSpecialStyles,
  blockquoteCiteSpecialStyles,
} from "./styles";
import { BlockquoteModule } from "../../carlsberg-headless/types/modules/Blockquote";
import { Container } from "@shared-components/Container/Container";
import { THEMES_MAP } from "../../carlsberg-headless/themes-map";
import { TAXONOMIES_MAP } from "../../carlsberg-headless/taxonomies-map";

export type BlockquoteProps = BlockquoteModule;

const Blockquote: React.FC<BlockquoteProps> = ({
  title,
  quoteText,
  cite,
  cbKey,
  taxonomies,
  themes,
}) => {
  if (!quoteText) return null;

  // Initialize an empty style object for text color
  const textColorStyles: ThemeUIStyleObject = {};

  // Check if the layout background theme is active, and apply copper text color if true
  if (themes.includes(THEMES_MAP.layout_bg.layout_bg_red)) {
    textColorStyles.color = "copper";
  }

  // Loop through the themes to set specific text colors based on theme
  for (const theme of themes) {
    switch (theme) {
      case THEMES_MAP.text_color.text_color_white:
        textColorStyles.color = "white";
        break;
      case THEMES_MAP.text_color.text_color_green:
        textColorStyles.color = "darkGreen";
        break;
      case THEMES_MAP.text_color.text_color_red:
        textColorStyles.color = "darkRed";
        break;
      default:
        // Do nothing for other themes
        break;
    }
  }

  // The final text color styles based on all active themes
  const colorStyles = textColorStyles;

  if (
    taxonomies?.includes(TAXONOMIES_MAP.blockquote.blockquote_special_layout)
  ) {
    return (
      <Container key={cbKey} sx={containerSpecialStyles}>
        <Box sx={{ ...blockquoteWrapSpecialStyles, ...colorStyles }}>
          {title && (
            <Heading as="h3" sx={blockquoteTitleSpecialStyles}>
              {title}
            </Heading>
          )}
          {quoteText && (
            <blockquote sx={blockquoteSpecialStyles}>{quoteText}</blockquote>
          )}
          {cite && <Text sx={blockquoteCiteSpecialStyles}>{cite}</Text>}
        </Box>
      </Container>
    );
  }

  return (
    <Container key={cbKey} sx={containerStyles}>
      <Box sx={{ ...blockquoteWrapStyles, ...colorStyles }}>
        {quoteText && (
          <blockquote {...(cite && { cite: cite })} sx={blockquoteStyles}>
            {quoteText}
          </blockquote>
        )}
        {cite && <Text sx={blockquoteCiteStyles}>{cite}</Text>}
      </Box>
    </Container>
  );
};

export { Blockquote };
